import React from "react";
import { useParams } from "react-router-dom";
import WayfinderLayout from "./WayfinderLayout";
import MobileScreenSettings from "./MobileScreenSettings";

const MobilePage = ({ buttonColor }) => {
  const { userId } = useParams();
  return <MobileScreenSettings userId={userId} buttonColor={buttonColor} value={0} />;
};

// Wrap with layout
const MobilePageWithLayout = () => (
  <WayfinderLayout>
    <MobilePage />
  </WayfinderLayout>
);

export default MobilePageWithLayout;
